import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useUserInfoQuery = getWrappedUseQuery(KEYS.GET_USER_INFO, apiClient.Users.get);

export const useUsersQuery = getWrappedUseQuery(KEYS.GET_USERS, apiClient.Users.getAll);
